module.exports = __webpack_public_path__ + "static/media/vamole-icon-stop.0498c574.png";